<template>
    <div class="wspro-product-listing">
        <div id="worksends-page-header" class="tw-mb-3">
              <div class="breadcrumbs" id="breadcrumbs">
                <router-link class="breadcrumb-link" to="/corporate-products/">All Corporate Products</router-link>
              </div>
                <h3>Your Corporate Products<span class="preview" v-if="team.plan!='pro'"> PREVIEW</span></h3>
                <div class="ws-button ws-button-main" @click="requestNewProduct">Request New Product</div>
        </div>
        <notification type="allocation"></notification>
        <div v-if="team.plan!='pro'" class="note"><span>Products Preview:</span> You are viewing a demo preview of various <b>Bookblock HUB Pro</b> bespoke corporate products. This is how your products page can look after you upgrade to <b>Bookblock HUB Pro</b>.</div>

        <div v-if="kittedBoxes">
            <h3 style="margin-bottom: 10px; font-size: 18px;">Your Kitted Boxes</h3>
            <div class="wspro-product-list">
                <div v-for="item in kittedBoxes" class="wspro-product-list-item">
                    <product-list-item :item="item" location="gifting-campaigns" @open-restock-modal="openRestockModal"></product-list-item>
                </div>
            </div>
        </div>

        <div v-if="otherProducts">
            <h3 style="margin-bottom: 10px; font-size: 18px;">Your Other Products</h3>
            <div class="wspro-product-list">
                <div v-for="item in otherProducts" class="wspro-product-list-item">
                    <product-list-item :item="item" location="gifting-campaigns"></product-list-item>
                </div>
            </div>
        </div>
        
        <div class="ws-table-meta"><div v-if="index.data && index.data.length" class="ws-table-sum">You have {{ index.data.length }} corporate products.</div></div>
        <div class="note warning" v-if="index.data && !index.data.length && !$wait.any"><b>You don't have any active corporate products.</b> To request a new product, click the button above. <br /><br />If you have already requested your product, please wait for your Account Manager to process your request. Once your product is ready, it will show up here. You can view your current product request on <a href="/corporate-products/requests">product requests page</a>.</div>

        <product-requests-modal v-if="modals.productRequestsCreate" :fetch-item="false" @created="onRequestCreated" :type="'create'"></product-requests-modal>
        <product-restock-modal v-if="modals.productRestock" :fetch-item="true" :product-id="restockProductId" @created="modals.productRestock = false"></product-restock-modal>
    </div>
</template>

<script>
import ProductRequestsModal from '@/pages/corporate-products/ProductRequestsModal';
import ProductRestockModal from "@/pages/corporate-products/ProductRestockModal";
import ProductListItem from "@/components/ProductListItem";

export default {
    name: "ProductsIndex",
    components: {ProductRestockModal, ProductRequestsModal, ProductListItem},
    data() {
        return {
            pageParams: {
                pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 200},
                search: {val: ""},
                filters: {}
            },
            errors: {},
            loaded: false,
            restockProductId: 0
        }
    },
    methods: {
        async getPage(params) {
            await this.getPageHandler({
                waitName: 'products.index',
                action: 'fetchProducts', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: {fetchDemoContent: this.team.plan=='pro' ? false : true }
            });
        },
        async fetchData() {

        },
        requestNewProduct() {
            if (!this.proCheck('Requesting custom products')) return; 
            this.modals.productRequestsCreate = true;
        },
        openRestockModal(id) {
            this.restockProductId = id;
            this.modals.productRestock = true;
        },
        onRequestCreated(requestId) {
            this.$router.push({ name: 'product-requests-detail', params: { id: requestId } });
            this.modals.productRequestsCreate = false;
        },
    },
    async mounted() {
        await this.getPage({init:true});
        await this.fetchData();
        this.loaded = true;
    },
    computed: {
        index() {
            return this.$store.state.product.index;
        },
        modals() {
            return this.$store.state.modals;
        },
        team() {
            return this.$store.state.team.detail;
        },
        kittedBoxes() {
            return this.index.data.filter(item => item.product_type === 'kitted');
        },
        otherProducts() {
            return this.index.data.filter(item => item.product_type !== 'kitted');
        }
    },
    watch: {
        'pageParams.pageOptions': {
            handler (newVal, oldVal) {
                if (this.loaded && oldVal != null) { // we need to load initial data based on url query instead
                    this.getPage();
                }
            },
            deep: true,
        },
    },
}
</script>

<style scoped>

</style>
